class OrderHistoryListMapper {
    map(list) {
        const reduced = list.reduce((list, order) => {
            if (!order.isActiveForRestaurant) {
                list.push(order)
            }

            return list
        }, [])

        return reduced
    }
}

export default new OrderHistoryListMapper()
